module.exports = __webpack_public_path__ + "static/media/photo297.23be5d76.jpg";